import { createClassName } from 'utils/createClassName';

import './sidebarModalNavigationStyles.scss';

export const createSidebarModalNavigationControlClassName = createClassName(
  'sidebarModalNavigationControl'
);

export const createSidebarModalNavigationLayoutClassName = createClassName(
  'sidebarModalNavigationLayout'
);
